<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>
            <el-menu-item index="/home/menu/conventionList">预约详情</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

    export default {
        name: 'project',
        data() {
            return {
                msg: '项目',
                activeIndex: '/home/menu/conventionList',
                handleSelect(key, keyPath) {
                    console.log(key, keyPath);
                }
            }
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// menu.vue?4857fe9c